import { UIMS_BASE } from '@/shared/utils';
function getUimsToPathName() {
    return () => { };
}
export const uimsToPathNameMap = (function () {
    return {
        uims1001: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/companyList/companyHandle?id=${businessKey}`;
        },
        uims1002: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/collaborate/btypeList/inviteDetails?id=${businessKey}`;
        },
        uims1003: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/collaborate/btypeList/checkCollaborate?id=${businessKey}`;
        },
        uims1004: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/superiorUnit/childUnit?id=${businessKey}`;
        },
        uims1005: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/superiorUnit/superiorUnitDetails?id=${businessKey}`;
        },
        uims1006: () => {
            return `${UIMS_BASE}/superiorUnit`;
        },
        uims1007: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/enterpriseManage/addTeam?id=${businessKey}`;
        },
        uims1011: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/companyCertify/certifyDetail?id=${businessKey}`;
        },
        uims1012: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/account/certifyDetail?id=${businessKey}`;
        },
        uims1040: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/account/certifyAccount?id=${businessKey}`;
        },
        uims1041: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/companyCertify?id=${businessKey}`;
        },
        uims1042: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/account/certifyAccount?id=${businessKey}`;
        },
        //  企业工商变更
        uims1016: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/companyCertify/companyCertifyChangeDetail?id=${businessKey}`;
        },
        uims1053: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/orgStructure/rolesAndMembers`;
        },
        // 邀请已可信认证的员工激活电子签章服务
        esign1010: `${UIMS_BASE}/account?buscode=esign1010`,
        // 先完成个人实名认证并激活电子签章服务
        esign1020: `${UIMS_BASE}/account?buscode=esign1020`,
        //跳转电子签章列表
        esign1000: `${UIMS_BASE}/esign/list`,
        // 资信资质信息
        finance8003: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/companyQualification?id=${businessKey}`;
        },
        // 企业认证信息
        finance8002: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/companyCertify/certifyDetail?id=${businessKey}`;
        },
        //价格表详情
        common1010: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/pricing-manage/information/detail?id=${businessKey}`;
        },
        //往来单位申请
        uims4100: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/correspondence-units/admission-application/detail?id=${businessKey}`;
        },
        //资源管理
        common1000: ({ businessKey } = {
            businessKey: '',
        }) => {
            return `${UIMS_BASE}/pricing-manage/resources/resource-list/detail?id=${businessKey}`;
        },
    };
})();
